import { FormikValues } from 'formik';
import React, { useRef } from 'react';

import { Card } from '@material-ui/core';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

import AppSnackbar from '../../../common/AppSnackbar';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateScar } from '../Scar.hook';
import { BaseScarCardProps, Scar } from '../Scar.interface';

const ProblemDetailCard: React.FC<BaseScarCardProps> = (
  props: BaseScarCardProps
) => {
  const formikRef = useRef<FormikValues>();
  const { scar, onChange } = props;
  const { description, rootCause } = scar;
  const { isUpdating, updateError, updateScar } = useUpdateScar(scar.id);
  const { isFieldDisabled } = useTaskEntityFields(scar.task);

  return (
    <Card>
      <CardTitle>
        <ReportProblemIcon />
        Problem Details
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          isSubmitting={isUpdating}
          initialValues={{
            description: description || '',
            rootCause: rootCause || ''
          }}
          onSubmit={(scarDto: Partial<Scar>) => {
            console.log('update scar');
            updateScar(scarDto);
            onChange?.(scarDto);
          }}
        >
          {({ values }) => (
            <InlineForm>
              <InlineTextField
                name='description'
                label='Description'
                disabled={isFieldDisabled('description')}
                value={values.description}
              />
              <InlineTextField
                name='rootCause'
                label='Root Cause'
                disabled={isFieldDisabled('rootCause')}
                value={values.rootCause}
              />
            </InlineForm>
          )}
        </InlineFormik>
      </CardContent>
      <AppSnackbar severity='error' open={Boolean(updateError)}>
        Error updating SCAR.
      </AppSnackbar>
    </Card>
  );
};

export default ProblemDetailCard;
